const Footer = () =>{

    return(
        <div className="relative  ">
                    <p className=" w-full absolute bottom-0 z-3 text-center text-white "> @All Rights Reserverd IEEE IPEC </p>

        </div>
    );
};
export default Footer;